import type { FallbackRender } from '@sentry/react/types/errorboundary';
import React from 'react';
import { ErrorLoadingEndUserApp } from './ErrorLoadingEndUserApp';

export const RootErrorRenderer: FallbackRender = () => {
  return <ErrorLoadingEndUserApp />;
};
